import { cn } from "../../utils/cn";
import type { SagaStatus, StepStatus } from "../../types/saga";
import type { TenantStatus } from "../../types/tenant";

type AnyStatus = SagaStatus | StepStatus | TenantStatus | string;

const STATUS_CLS: Record<string, { dot: string; label: string }> = {
  // SagaStatus
  RUNNING: { dot: "bg-primary", label: "bg-primary-soft text-primary-soft-fg border-primary/20" },
  COMPENSATING: { dot: "bg-primary", label: "bg-primary-soft text-primary-soft-fg border-primary/20" },
  SUCCESS: { dot: "bg-success", label: "bg-success-soft text-success-soft-fg border-success/20" },
  FAILED: { dot: "bg-danger", label: "bg-danger-soft text-danger-soft-fg border-danger/20" },
  FAILED_NEEDS_MANUAL: { dot: "bg-warning", label: "bg-warning-soft text-warning-soft-fg border-warning/30" },
  // StepStatus (alguns colidem com SagaStatus, mantendo o mesmo styling)
  PENDING: { dot: "bg-muted-foreground", label: "bg-surface-2 text-muted-foreground border-border" },
  OK: { dot: "bg-success", label: "bg-success-soft text-success-soft-fg border-success/20" },
  COMPENSATED: { dot: "bg-warning", label: "bg-warning-soft text-warning-soft-fg border-warning/30" },
  COMPENSATION_FAILED: { dot: "bg-danger", label: "bg-danger-soft text-danger-soft-fg border-danger/30" },
  // TenantStatus
  PROVISIONING: { dot: "bg-primary", label: "bg-primary-soft text-primary-soft-fg border-primary/20" },
  ACTIVE: { dot: "bg-success", label: "bg-success-soft text-success-soft-fg border-success/20" },
  ARCHIVED: { dot: "bg-muted-foreground", label: "bg-surface-2 text-muted-foreground border-border" },
};

const FALLBACK = { dot: "bg-muted-foreground", label: "bg-surface-2 text-muted-foreground border-border" };

export interface StatusPillProps {
  status: AnyStatus;
  className?: string;
  size?: "xs" | "sm";
}

export function StatusPill({ status, className, size = "sm" }: StatusPillProps) {
  const cls = STATUS_CLS[status as string] ?? FALLBACK;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded border font-medium font-mono-tight tracking-tight",
        size === "xs" ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-xs",
        cls.label,
        className,
      )}
    >
      <span
        className={cn("rounded-full", cls.dot, size === "xs" ? "w-1 h-1" : "w-1.5 h-1.5")}
        aria-hidden="true"
      />
      {status}
    </span>
  );
}
